const HEX_COLOR = /^#[0-9a-f]{6}$/i;

export const PictogramImage = ({ pictogram, className = "w-12 h-12", testId, alt }) => {
  const path = pictogram.icon_url || (pictogram.icon_file_id && `/api/files/${pictogram.icon_file_id}`);
  const src = path && (path.startsWith("http") ? path : `${process.env.REACT_APP_BACKEND_URL}${path}`);
  const title = alt ?? pictogram.name;
  const color = pictogram.color_hex && HEX_COLOR.test(pictogram.color_hex) ? pictogram.color_hex : null;

  if (!src) return <span className={`inline-flex items-center justify-center border border-dashed border-[#A0A0A0] text-[#707070] ${className}`}
                         aria-label="Icona da caricare" role="img" data-testid={testId}>—</span>;
  if (!color) return <img src={src} alt={title} className={`object-contain ${className}`} data-testid={testId} />;
  return <span role="img" aria-label={title} className={`inline-block shrink-0 ${className}`}
               data-testid={testId} style={{ backgroundColor: color,
                filter: (pictogram.is_default || pictogram.is_default_derivative) && color.toUpperCase() === "#1A1A1A"
                   ? "invert(var(--picto-invert, 0))" : undefined,
                 WebkitMaskImage: `url("${src}")`, maskImage: `url("${src}")`,
                 WebkitMaskSize: "contain", maskSize: "contain",
                 WebkitMaskPosition: "center", maskPosition: "center",
                 WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat" }} />;
};